// Langues du site — configuration.
//
// Ajouter une langue = ajouter un dossier `src/i18n/locales/<code>/` contenant un fichier
// `_language.json` (nom, locale…) et les fichiers de traduction (`<espace>.json`) : aucun composant
// à modifier. Elle n'apparaît sur le site que si son code figure dans REACT_APP_I18N_LANGS.
//
// INTERRUPTEUR GÉNÉRAL : sans cette variable, le site est en français SEUL (pas de sélecteur de
// langue, pas de balises hreflang, adresses inchangées) — c'est le comportement de la mise en
// ligne actuelle. Pour publier des langues : créer le fichier `.env.production` à la racine avec
//     REACT_APP_I18N_LANGS=fr,en,de,es
// puis `npm run build` (voir docs/multilingue-mode-emploi.md, « Mise en ligne d'une langue »).
// En développement, `.env.development` active toutes les langues pour les essais.

export const DEFAULT_LANG = 'fr';
export const SITE_URL = 'https://joli-mot.fr';

// Fiches des langues connues : chaque dossier de locales/ a son `_language.json`
// (code, label = nom dans sa propre langue, locale = pour Intl, ogLocale = pour og:locale, dir).
const ALL = {};
try {
  // require.context est résolu à la compilation (webpack) ; il n'existe pas sous Jest → le try/catch.
  const fiches = require.context('./locales', true, /^\.\/[a-z]{2,3}\/_language\.json$/);
  fiches.keys().forEach((k) => {
    const langue = fiches(k);
    ALL[langue.code] = langue;
  });
} catch (e) { /* hors webpack : français seul, ci-dessous */ }
if (!ALL[DEFAULT_LANG]) {
  ALL[DEFAULT_LANG] = { code: 'fr', label: 'Français', locale: 'fr-FR', ogLocale: 'fr_FR', dir: 'ltr' };
}

const demandees = String(process.env.REACT_APP_I18N_LANGS || DEFAULT_LANG)
  .split(',').map((c) => c.trim().toLowerCase()).filter((c) => ALL[c]);
if (!demandees.includes(DEFAULT_LANG)) demandees.unshift(DEFAULT_LANG);

/** Langues actives sur ce site, dans l'ordre du sélecteur (le français d'abord). */
export const LANGUAGES = [...new Set(demandees)].map((c) => ALL[c]);
export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const isEnabledLang = (code) => LANG_CODES.includes(code);
export const getLanguage = (code) => ALL[code] || ALL[DEFAULT_LANG];
/** Il y a un choix de langue à proposer (sinon : pas de sélecteur, pas de hreflang). */
export const IS_MULTILINGUAL = LANGUAGES.length > 1;

// Espaces de noms chargés en parallèle AVANT le premier affichage d'une langue autre que le
// français (ce que l'en-tête, le bandeau et le pied de page affichent d'emblée). Un espace absent de
// cette liste fonctionne aussi : il est chargé à la demande, avec une brève attente.
export const SHELL_NAMESPACES = ['common', 'seo', 'header', 'breadcrumb', 'life-events', 'consent', 'demo-banner'];

// Pages qui n'ont PAS de version par langue dans l'adresse : elles restent à leur adresse d'origine
// et prennent la langue de leur lecteur (?lang=xx dans le lien, sinon langue du navigateur) — les
// pages des destinataires d'une carte ou d'un faire-part — ou ne sont pas traduites (administration).
export const RECIPIENT_PREFIXES = ['/carte-a-gratter/', '/carte-surprise/', '/carte-old/', '/i/', '/apercu-mini-site'];
export const ADMIN_PREFIXES = ['/gestion-', '/list-cards', '/creer-card', '/edit-card', '/analytics', '/trackers',
  '/tunnel-acquisition', '/bibliotheque-visuels'];

// Code de langue de la balise PayPal (null = laisser PayPal choisir, comme avant l'internationalisation).
export const paypalLocale = (code) => (code === DEFAULT_LANG ? null : (getLanguage(code).paypalLocale || null));
